import Vue from 'vue' ;
import { namespace } from 'vuex-class';
import { DOCUMENT_MODULE_NAMESPACE, DOCUMENT_SET_DOCUMENT } from '../../../../store/document';
import { IDocument } from '../../../../models/documents/document';

const DocumentStore= namespace(DOCUMENT_MODULE_NAMESPACE)

export class DocumentViewModel extends Vue {
    constructor(){
        super()
    }

    @DocumentStore.Getter document: IDocument

    @DocumentStore.Mutation(DOCUMENT_SET_DOCUMENT)
    storeSetDocumentByValue: (document: IDocument) => void

    get type(){
        return this.document.type
    }

    set type(type:number){
        this.storeSetDocumentByValue({ type })
    }

    get attachments(){
        return this.document.attachments
    }

    set attachments(attachments: any[] ){
        this.storeSetDocumentByValue({ attachments })
    }

    get blocks(){
        return this.document.blocks
    }

    set blocks(blocks: number[]){
        this.storeSetDocumentByValue({ blocks })
    }

    get apartments(){
        return this.document.apartments
    }

    set apartments(apartments: number[]){
        this.storeSetDocumentByValue({ apartments })
    }

    get shareWithManagers(){
        return (this.document.share as any).includes("agencyMember")
    }

    set shareWithManagers(share: boolean){
        this.storeSetDocumentByValue({ share: share ? this.extend_share("agencyMember") : this.filter_share("agencyMember") })
    }

    get shareWithBlockOwners(){
        return (this.document.share as any).includes("ownerBlock")
    }

    set shareWithBlockOwners(share: boolean){
        this.storeSetDocumentByValue({ share: share ? this.extend_share("ownerBlock") : this.filter_share("ownerBlock") })
    }

    get shareWithBlockTenants(){
        return (this.document.share as any).includes("tenantBlock")
    }

    set shareWithBlockTenants(share: boolean){
        this.storeSetDocumentByValue({ share: share ? this.extend_share("tenantBlock") : this.filter_share("tenantBlock") })
    }

    get shareWithApartmentOwners(){
        return (this.document.share as any).includes("ownerApartment")
    }

    set shareWithApartmentOwners(share: boolean){
        this.storeSetDocumentByValue({ share: share? this.extend_share("ownerApartment") : this.filter_share("ownerApartment") })
    }

    get shareWithApartmentTenants(){
        return (this.document.share as any).includes("tenantApartment")
    }

    set shareWithApartmentTenants(share: boolean){
        this.storeSetDocumentByValue({ share: share ? this.extend_share("tenantApartment") : this.filter_share("tenantApartment") })
    }

    get entities(){
        return this.document.entities
    }

    set entities(entities: number[]){
        this.storeSetDocumentByValue({ entities })
    }

    filter_share(type: string){
        return this.document.share.filter(item=> item !== type)
    }

    extend_share(type: string){
        return [...this.document.share,type]
    }
}



// WEBPACK FOOTER //
// ./src/containers/building-monitor/components/bm-plan-modal-vertical/document.viewmodel.ts